import React, { createContext, useContext, useState, useEffect } from "react";

/**
 * UserPreferenceContext
 * Tracks user preferences like default tab selections for work experience and project filters
 * Used to personalize experience based on entry point (e.g., /swe for software focus)
 */
const UserPreferenceContext = createContext();

export const UserPreferenceProvider = ({ children }) => {
  const [defaultTab, setDefaultTab] = useState(() => {
    // Check sessionStorage for existing preference
    return sessionStorage.getItem("defaultTab") || "systems";
  });

  const [defaultProjectCategory, setDefaultProjectCategory] = useState(() => {
    // Check sessionStorage for existing preference
    return sessionStorage.getItem("defaultProjectCategory") || "All";
  });

  // Save preferences to sessionStorage when they change
  useEffect(() => {
    sessionStorage.setItem("defaultTab", defaultTab);
  }, [defaultTab]);

  useEffect(() => {
    sessionStorage.setItem("defaultProjectCategory", defaultProjectCategory);
  }, [defaultProjectCategory]);

  const setSoftwarePreference = () => {
    setDefaultTab("software");
    setDefaultProjectCategory("Software");
  };

  const resetPreferences = () => {
    setDefaultTab("systems");
    setDefaultProjectCategory("All");
    sessionStorage.removeItem("defaultTab");
    sessionStorage.removeItem("defaultProjectCategory");
  };

  return (
    <UserPreferenceContext.Provider
      value={{
        defaultTab,
        defaultProjectCategory,
        setDefaultTab,
        setDefaultProjectCategory,
        setSoftwarePreference,
        resetPreferences,
      }}
    >
      {children}
    </UserPreferenceContext.Provider>
  );
};

export const useUserPreference = () => {
  const context = useContext(UserPreferenceContext);
  if (!context) {
    throw new Error("useUserPreference must be used within UserPreferenceProvider");
  }
  return context;
};
